module.exports = __webpack_public_path__ + "static/media/image-2.b94929f2.jpg";